/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveSamplePrompt } from '../models/ActiveSamplePrompt';
import type { CreateSamplePromptRequest } from '../models/CreateSamplePromptRequest';
import type { SamplePrompt } from '../models/SamplePrompt';
import type { SamplePromptListResponse } from '../models/SamplePromptListResponse';
import type { SamplePromptSort } from '../models/SamplePromptSort';
import type { UpdateSamplePromptRequest } from '../models/UpdateSamplePromptRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SamplePromptService {

    /**
     * List the tenant's sample prompt library
     * Returns a page of the authenticated user's tenant prompt library, active and inactive alike. Defaults to 50 rows from offset 0. `search` matches the label only. Every sort is resolved deterministically so pages cannot overlap.
     * @returns SamplePromptListResponse Success
     * @throws ApiError
     */
    public static getSamplePrompts({
        search,
        sort,
        limit,
        offset,
    }: {
        /**
         * Case-insensitive substring match on the prompt label.
         */
        search?: string,
        /**
         * Sorting options. Defaults to most recently updated first.
         */
        sort?: SamplePromptSort,
        /**
         * Pagination limit
         */
        limit?: number,
        /**
         * Pagination offset
         */
        offset?: number,
    }): CancelablePromise<SamplePromptListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/samplePrompt',
            query: {
                'search': search,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Create a sample prompt
     * Creates a prompt in the authenticated user's tenant. Rejected with 400 when `status` is `inactive` and `featured` is `true` — an inactive prompt cannot be featured. Rejected with 409 when it would take the tenant past 15 active prompts, or past 4 featured among the active ones — see the 409 response.
     * @returns SamplePrompt Success
     * @throws ApiError
     */
    public static createSamplePrompt({
        requestBody,
    }: {
        requestBody: CreateSamplePromptRequest,
    }): CancelablePromise<SamplePrompt> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/samplePrompt',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `A prompt limit would be exceeded. Body carries a machine-readable \`errorCode\` identifying which limit.`,
            },
        });
    }

    /**
     * Get the tenant's active sample prompts
     * Returns every active prompt in the authenticated user's tenant, in a stable order, for display in Ask Bettercomp. Not paginated — the pool is capped at 15. A tenant with no active prompts gets an empty array, not an error. Requires authentication only; no permission and no feature gate.
     * @returns ActiveSamplePrompt Success
     * @throws ApiError
     */
    public static getActiveSamplePrompts(): CancelablePromise<Array<ActiveSamplePrompt>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/samplePrompt/active',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Update a sample prompt
     * Replaces the editable fields of a prompt in the authenticated user's tenant. A prompt belonging to another tenant is not found. Rejected with 400 when `status` is `inactive` and `featured` is `true` — an inactive prompt cannot be featured. Rejected with 409 when the change would take the tenant past 15 active prompts, or past 4 featured among the active ones; a change breaching both reports the active limit.
     * @returns SamplePrompt Success
     * @throws ApiError
     */
    public static updateSamplePrompt({
        id,
        requestBody,
    }: {
        /**
         * Sample prompt ID
         */
        id: number,
        requestBody: UpdateSamplePromptRequest,
    }): CancelablePromise<SamplePrompt> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/samplePrompt/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `A prompt limit would be exceeded. Body carries a machine-readable \`errorCode\` identifying which limit.`,
            },
        });
    }

    /**
     * Delete a sample prompt
     * Permanently deletes a prompt in the authenticated user's tenant. There is no restore. A prompt belonging to another tenant is not found.
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSamplePrompt({
        id,
    }: {
        /**
         * Sample prompt ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/samplePrompt/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
